import useU2000AxiosNonAuthenticated from "../../axios/U2000UseAxiosNonAuthenticated";
import { useU2000AuthContext } from "../../context/auth/U2000UseAuthContext";

const LOGICALUNIT_URL = "U2001";
const RESETPASWORD_URL = LOGICALUNIT_URL + "/resetPassword";

type ResetPasswordFn = (username: string, secretKey: string) => Promise<any>; // Remplacer any par le type réel si connu

const useU2000ResetPassword = (): ResetPasswordFn => {
  const { prelogin } = useU2000AuthContext();
  const u2000AxiosNonAuthenticated = useU2000AxiosNonAuthenticated();

  const doResetPassword: ResetPasswordFn = async (username, secretKey) => {
    try {
      const response = await u2000AxiosNonAuthenticated.post(RESETPASWORD_URL, JSON.stringify({ username, secretKey }));
      return prelogin(response.data);
    } catch (error) {
      throw error;
    }
  };
  return doResetPassword;
};

export default useU2000ResetPassword;
